import firebase from 'firebase';

const settings = {timestampsInSnapshots: true};

let config = {
	apiKey: "AIzaSyDG5Ow-dKdFEdiZ7_4lXgmo9kc7if_5fqw",
    authDomain: "projetox-688ca.firebaseapp.com",
    databaseURL: "https://projetox-688ca.firebaseio.com",
    projectId: "projetox-688ca",
    storageBucket: "projetox-688ca.appspot.com",
    messagingSenderId: "588023699396",
    appId: "1:588023699396:web:cf9e9ef053fc1840"
}
//firebase.initializeApp(config);
let app = firebase.initializeApp(config);

export default firebase;

